<template>
  <div class="aboutUs">
    <div class="boxCenter">
      <div class="activeDetail">
        <div class="imgBox">
          <img :src="dataObj.pic">
          <p class="theme">{{dataObj.themName}} | {{dataObj.startLocation}}{{dataObj.classify == 1 ? '' : '出发'}}</p>
        </div>
        <div class="infoBox">
          <div class="activeName"><span>{{dataObj.themName}}</span>{{dataObj.name}}</div>
          <div class="intro">{{dataObj.intro}}</div>
          <div class="traveTime">行程天数：<span>{{dataObj.cycle}}</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;套餐：<span>{{property?property:'无'}}</span></div>
          <div class="price">
            <template v-if="dataObj.price>0">
              <span class="priceType">成人价格：</span>￥<span class="priceNum">{{dataObj.price.toFixed(2)}}</span>元
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </template>
            <template v-if="dataObj.childPrice>0">
              <span class="priceType">儿童价格：</span>￥<span class="priceNum">{{dataObj.childPrice.toFixed(2)}}</span>元
            </template>
          </div>
        </div>
      </div>
      <div class="addInfoTip">请填写以下内容，感谢大家的参与以及支持。</div>
      <div class="formBox">
        <div class="formTitle">我的信息</div>
        <div class="myInfo">
          <div class="formPosition1">
            <el-form label-position="right" label-width="125px" ref="form" :model="userData" :rules="rules">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="userData.name"></el-input>
              </el-form-item>
              <el-form-item label="身份证" prop="idNumber">
                <el-input v-model="userData.idNumber"></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="phoneNum">
                <el-input v-model="userData.phoneNum"></el-input>
              </el-form-item>
              <el-form-item label="紧急联系人姓名" prop="emergPerson">
                <el-input v-model="userData.emergPerson"></el-input>
              </el-form-item>
              <el-form-item label="紧急联系人号码" prop="emergPhone">
                <el-input v-model="userData.emergPhone"></el-input>
              </el-form-item>
              <el-form-item label="地址信息" prop="address">
                <el-input v-model="userData.address"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="formTitle">报名数量</div>
        <div class="myInfo">
          <div class="formPosition1">
            <el-form label-position="right" label-width="125px" :model="dataObj" :rules="rules">
              <el-form-item label="成人" v-show="dataObj.checkPrice == 1 && dataObj.price > 0">
                <el-input-number v-model="formdata.num" :min="0" label="描述文字"></el-input-number>
                <span class="unit">{{dataObj.price?dataObj.price.toFixed(2):''}}元/人</span>
                <p class="ageTip">(18周岁及以上)</p>
              </el-form-item>
              <el-form-item label="儿童" v-show="dataObj.checkChildPrice == 1 && dataObj.childPrice > 0">
                <el-input-number v-model="formdata.childNum" :min="0" label="描述文字"></el-input-number>
                <span class="unit">{{dataObj.childPrice?dataObj.childPrice.toFixed(2):''}}元/人</span>
                <p class="ageTip">(18周岁以下)</p>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="formTitle">活动开始时间</div>
        <div class="myInfo">
          <div class="formPosition1" style="width: 630px">
            <el-form label-position="right" label-width="125px" :model="formdata" :rules="rules">
              <el-form-item label="活动开始时间" prop="travelDate">
                <el-select v-model="formdata.travelDate" placeholder="请选择活动开始时间" style="width: 310px;">
                  <el-option v-for="(item,index) in dataObj.travelDates" :key="index" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注">
                <el-input type="textarea" :rows="5" :maxlength="500" v-model="formdata.remark"></el-input>
                <p style="margin-top: 5px;font-size: 12px;color: #999;">备注信息字数限制500字</p>
                <p style="color: #ff0000;font-size: 14px;">*请把其他报名人的姓名、身份证、手机号码、地址、紧急联系人信息填写在此</p>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="formTitle">积分抵现</div>
        <div class="myInfo">
          <div class="formPosition1">
            <el-form label-position="right" label-width="125px" :model="formdata" :rules="rules">
              <el-form-item label="我的积分"><span class="points">{{userData.points}}</span></el-form-item>
              <el-form-item label="本次使用">
                <el-input type="number" v-model="formdata.credits" v-on:input="countCredits"></el-input>
                <p class="ageTip">本活动最高可用{{dataObj.pointsFree}}积分抵扣{{pointsToMoney}}元</p>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <div class="formBox" style="padding: 0px; margin: 17px 0 5px;">
        <div class="paybox">合计：<span class="spanMoney">{{payMoney}}</span> <span class="payBtn" @click="confirmOrder">去付款</span></div>
      </div>
      <!-- <div class="aboutInfo">
        <div class="title" style="margin: 30px 0;"><span class="name">订单确认</span> message board<span class="brick"></span></div>
        
        <div style="margin-top: 20px;"><el-button disabled>确 认</el-button></div>
      </div> -->
    </div>
  </div>
</template>

<script>
  import eventVue from '../bus.js'
  export default {
    data(){
      //验证有没有选择人数
      var validateNum = (rule, value, callback) => {
          if(this.totalMoney <= 0){
              callback(new Error('请选择出行人数'));
          }else {
             callback();
          }
      };
      return {
        activityId:'',
        dataObj:{},
        userData:{
          name:'',
          idNumber:'',
          phoneNum:'',
          emergPerson:'',
          emergPhone:'',
          address:'',
          points:'',
          id:''
        },
        deductRate:0,//积分兑换比
        distrUserId:null,//分销ID
        formdata:{
          num:0,
          childNum:0,
          travelDate:null,
          preferential:0,
          credits:0,
        },
        priceShow:false,
        childPriceShow: false,
        property:'',

        rules:{
          name:[{required: true, trigger: 'blur',message:'请输入姓名'},],
          idNumber:[{required: true, trigger: 'blur',message:'请输入身份证'},],
          phoneNum:[{required: true, trigger: 'blur',message:'请输入手机号码'},],
          address:[{required: true, trigger: 'blur',message:'请输入联系地址'},],
          emergPerson:[{required: true, trigger: 'blur',message:'请输入紧急联系人'},],
          emergPhone:[{required: true, trigger: 'blur',message:'请输入紧急联系人号码'},],

          travelDate:[{required: true, trigger: 'change',message:'请选择活动开始时间'},],

          num:[{trigger: 'change',validator:validateNum,message:'请选择报出行人数'},],
        },
      }
    },
    computed: {
      pointsToMoney:function(){
        return (this.dataObj.pointsFree * this.deductRate).toFixed(2)
      },
      totalMoney:function(){
        let price1 = parseInt(this.formdata.num)*this.dataObj.price;
        let price2 = parseInt(this.formdata.childNum)*this.dataObj.childPrice
        if(isNaN(price1)){
          price1 = 0
        }
        if(isNaN(price2)){
          price2 = 0
        }
        return  (price2+ price1).toFixed(2)
      },
      payMoney:function(){
        let price1 = parseInt(this.formdata.num)*this.dataObj.price;
        let price2 = parseInt(this.formdata.childNum)*this.dataObj.childPrice
        if(isNaN(price1)){
          price1 = 0
        }
        if(isNaN(price2)){
          price2 = 0
        }
        let point = parseInt(this.formdata.credits)
        if(isNaN(point)){
          point = 0
        }
        return ((price2+price1)-(point*this.deductRate)).toFixed(2)
      },
    },
    created(){
      this.activityId = this.$route.query.id
      let _tempData = this.$store.state.userData
      //this.userData = JSON.parse(JSON.stringify(this.$store.state.userData))
      this.userData.name = _tempData.name
      this.userData.idNumber = _tempData.idNumber
      this.userData.phoneNum = _tempData.phoneNum
      this.userData.emergPerson = _tempData.emergPerson
      this.userData.emergPhone = _tempData.emergPhone
      this.userData.address = _tempData.address
      this.userData.points = _tempData.points
      this.userData.id = _tempData.id

      this.loadInforData()
      this.loadDeductRate()
    },
    mounted(){
      this.property = this.$route.query.propertyArr
    },
    methods:{
      loadInforData(){
        this.$https.get('/api/travel/id/'+this.activityId).then((response)=>{
          if(this.$route.query.price){
            response.data.price = parseFloat(this.$route.query.price)
          }
          if(this.$route.query.childPrice){
            response.data.childPrice = parseFloat(this.$route.query.childPrice)
          }
          this.dataObj = response.data
        }).catch((error) => {});
      },
      //获取积分兑换比
      loadDeductRate(){
        this.$https.get('/api/point/getPointRule').then((response)=>{
          this.deductRate = response.data
        }).catch((error) => {});
      },
      //输入积分计算
      countCredits(){
        if(this.formdata.credits == '' || this.formdata.credits == null){
          this.formdata.preferential = 0
          return
        }
        let piont = parseInt(this.formdata.credits)
        if(isNaN(piont)){
          this.$message('请输入有效积分值!')
          this.formdata.credits = 0
        }
        if(this.formdata.credits > this.userData.points){
          this.$message('超过您当前所拥有积分'+this.userData.points)
          this.formdata.credits = this.userData.points
        }
        if(this.formdata.credits > this.availablePoints){
          this.$message('超过该活动可使用积分'+this.availablePoints)
          this.formdata.credits = this.availablePoints
        }
        this.formdata.preferential = (this.formdata.credits*this.deductRate).toFixed(2)
      },
      confirmOrder(){
        this.$refs["form"].validate((valid) => {
          if (this.totalMoney == 0) {
            this.$message.warning('请选择出行人数')
            return
          }
          if (this.formdata.travelDate == null || this.formdata.travelDate == '') {
            this.$message.warning('请选择活动开始时间')
            return
          }

          let data = {
            travelId: this.dataObj.id,
            memberId: this.userData.id,
            name: this.dataObj.name,
            travelDate: this.formdata.travelDate,
            pic: this.dataObj.pic,
            childPrice: this.dataObj.childPrice,
            childNum: this.formdata.childNum ? this.formdata.childNum: 0,
            price: this.dataObj.price,
            num: this.formdata.num ? this.formdata.num : 0,
            remark: this.formdata.remark,

            total: this.totalMoney,
            pay: this.payMoney,

            credits: this.formdata.credits ? this.formdata.credits : 0,
            preferential: this.formdata.preferential,
            distrUserId: this.distrUserId,
            property:this.property
          }

          this.$https.post('/api/travelOrder/addTravelOrder?name='+this.userData.name+'&phoneNum='+this.userData.phoneNum+'&idNumber='+this.userData.idNumber+'&address='
            +this.userData.address+'&emergPerson='+this.userData.emergPerson+'&emergPhone='+this.userData.emergPhone,data).then((response)=>{
              if(response.code == 0){
                eventVue.$emit("getUserInfo")
                this.$router.replace('/orderDetails/'+response.data)
              }else{
                this.$message.warning(response.message)
              }
          }).catch((error) => {});

        })
      }
    }
  }
</script>

<style scoped>
  .activeDetail{

  }
  .activeDetail .imgBox{
    width: 50%;
    margin: 50px auto;
    position: relative;
    /*height: 450px;*/
  }
  .activeDetail .imgBox img{
    display: block;
    width: 100%;
    /*height: 100%;
    object-fit: cover;*/
  }
  .activeDetail .imgBox .theme{
    position: absolute;
    top: 23px;
    left: 28px;
    border-radius: 32px;
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
    color: #ffffff;
    background: rgba(0,0,0,0.5);
  }
  .activeDetail .infoBox{
    margin-top: 2px;
    background: #ffffff;
    padding: 18px 33px 50px;
    position: relative;
    box-shadow: 0px 2px 6px #ddd;
  }

  .activeDetail .infoBox .activeName{
    max-height: 90px;
    line-height: 30px;
    font-size: 16px;
    font-weight: bold;
  }
  .activeDetail .infoBox .activeName span{
    float: left;
    font-weight: normal;
    line-height: 28px;
    padding: 0 10px;
    background: #ffcd30;
    color: #ffffff;
    font-size: 14px;
    border-radius: 3px;
  }
  .activeDetail .infoBox .intro{
    color: #fe5a43;
    font-size: 14px;
    line-height: 21px;
    max-height: 42px;
    overflow: hidden;
    margin-top: 10px;
  }
  .activeDetail .infoBox .traveTime{
    /*position: absolute;
    left: 33px;
    bottom: 20px;*/
    color: #363636;
    font-size: 14px;
    margin-top: 20px;
  }
  .activeDetail .infoBox .traveTime span{
    font-size: 13px;
    font-weight: bold;
  }
  .activeDetail .infoBox .price{
    position: absolute;
    right: 33px;
    bottom: 20px;
    color: #ffcd30;
    font-size: 16px;
  }
  .activeDetail .infoBox .price .priceNum{
    font-size: 48px;
  }
  .activeDetail .infoBox .price .priceType{
    color: #333333;
    font-size: 14px;
    position: relative;
    top: -2px;
  }
  .addInfoTip{
    height: 118px;
    line-height: 118px;
    text-align: center;
    font-size: 16px;
    color: #666666;
  }
  .formBox{
    background: #ffffff;
    box-shadow: 0px 2px 6px #ddd;
    padding-bottom: 60px;
  }
  .formTitle{
    height: 140px;
    line-height: 140px;
    text-align: center;
    font-size: 24px;
    color: #5680f9;
    background: url("../assets/images/aOrderComfirm.png") center no-repeat;
  }
  .myInfo{
    width: 1048px;
    padding: 0px 0 10px;
    margin: 0 auto;
    border: 1px solid #e5e5e5;
  }
  .formPosition1{
    padding: 30px 0 0 260px;
    width: 450px;
  }
  .ageTip{
    font-size: 12px;
    color: #919191;
  }
  .points{
    color: #fa9551;
  }
  .unit{
    color: #919191;
    font-size: 14px;
  }
  .paybox{
    height: 65px;
    line-height: 65px;
    padding-right: 212px;
    font-size: 18px;
    color: #363636;
    text-align: right;
    position: relative;
  }
  .paybox .payBtn{
    position: absolute;
    right: 0px;
    top: 0px;
    display: block;
    width: 148px;
    height: 65px;
    line-height: 65px;
    text-align: center;
    background: #5680f9;
    color: #ffffff;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
  }
  .paybox .spanMoney{
    color: #5680f9;
    font-weight: bold;
  }
  /deep/ .el-input-number{
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/activeOrderConfirm.vue